/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import * as tsx from 'vue-tsx-support';
import { AssignmentsStore, SiteSettingsStore } from '@/store';
import * as utils from '@/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export default tsx.componentFactoryOf().create({
    name: 'help-homepage-link',
    functional: true,
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(_, ctx) {
        const assignmentId = utils.maybeParseOrKeepFloat(ctx.parent.$route.params.assignmentId);
        const assignment = assignmentId.chain(AssignmentsStore.getAssignment());
        const course = assignment.chain(a => a.maybeCourse);
        const isStudent = course.mapOrDefault(c => c.isStudent, false);
        const version = SiteSettingsStore.releaseInfo().mapOrDefault(r => r.version ?? `#${r.commit.substring(0, 7)}`, '...');
        const documentationUrl = isStudent
            ? `https://help.codegrade.com/for-students/getting-started?v=${version}`
            : `https://help.codegrade.com/?v=${version}`;
        return (<a target="_blank" {...ctx.data} class={[ctx.data.class, ctx.data.staticClass]} href={documentationUrl} style={[ctx.data.staticClass, ctx.data.class]}>
                {utils.renderScopedSlot({}, ctx.scopedSlots.default, () => 'Help')}
            </a>);
    },
});
